import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageAtmosphere } from './design-system/PageAtmosphere';
import { MarketingNav } from './marketing/MarketingNav';
import { PublicMarketingChromeContext } from './marketing/publicMarketingChrome';
import { WWW_PAGE_SHELL_MIN_H_CLASS } from '../lib/wwwViewportShell';

/**
 * Persistent www chrome for homepage / menu / auth so route changes do not
 * remount the nav or atmosphere (opacity flash on phone-width).
 */
export function PublicMarketingLayout() {
  const { pathname } = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname]);

  return (
    <PublicMarketingChromeContext.Provider value={true}>
      <div className={`relative ${WWW_PAGE_SHELL_MIN_H_CLASS} bg-[var(--bg-primary)]`}>
        <PageAtmosphere />
        <MarketingNav
          mobileMenuOpen={mobileMenuOpen}
          onMobileMenuOpenChange={setMobileMenuOpen}
        />
        <Outlet />
      </div>
    </PublicMarketingChromeContext.Provider>
  );
}

export default PublicMarketingLayout;
